import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome';
import { Button, ButtonToolbar, Tabs, Tab, Row, Col, DropdownButton, MenuItem,Form,FormGroup } from 'react-bootstrap'
import {Checkbox} from 'react-icheck'
import TyreStore from 'stores/TyreStore'
import WorkdocStore from 'stores/WorkdocStore'
import './Tyre.css';
import IMG from '../../asset/img/tyre-truck-top-view-22w.png'
import Select from 'react-select';
import AssetVehicleGenForm from './AssetVehicleGenForm'
import {connect} from 'react-redux'
// import { Checkbox, Radio } from 'react-icheck'
import AssetVehicleOperation from './AssetVehicleOperation'
import ConfirmPopup from 'component/element/ConfirmPopup'

const NotificationSystem = require('react-notification-system');
const DEFAULT_PART_POSITIONS = require('./part_position_22w');
const DEFAULT_TREAD_DEPTH_PART_POSITIONS = require('./part_tread_depth_part_position_22w');
const HEAD_LIST = [1,2,3,4,5,6,7,8,9,10];
const TAIL_LIST = [11,12,13,14,15,16,17,18,19,20,21,22];
class AssetVehicleServiceDoc extends Component {
  constructor(props) {
    super(props)

    this.state = {	 	
      loading:false,
      data:[],
      activeKey:0,
      activeMenu:undefined,
      _activeMenu:undefined,
      showTab:true,
      showOpt:false,
      partId:'',
      _partId:'',
      partPositions:JSON.parse(JSON.stringify(DEFAULT_PART_POSITIONS)),
      _partPositions:JSON.parse(JSON.stringify(DEFAULT_PART_POSITIONS)),
      treadDepthPartPositions:JSON.parse(JSON.stringify(DEFAULT_TREAD_DEPTH_PART_POSITIONS)),
      treadDepthPartId:[],
      vehicle_id:'',
      vehicle:{},
      dataSwapHistory:[],
      dataReplaceHistory:[],
      showConfirmDel:false,
      showModeChange:false,
      formData:{},
      historyRecord:[],
      historyRecordAt:[],
      hasHead:false,hasTail:false,
      tyreChangePartPositions:JSON.parse(JSON.stringify(DEFAULT_TREAD_DEPTH_PART_POSITIONS)),
      tyreRepairPartPositions:JSON.parse(JSON.stringify(DEFAULT_TREAD_DEPTH_PART_POSITIONS)),
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
    if(this.props.workNo!==''&&this.props.mode==='tyre-work-doc-entry-view'){
        this.loadInfo(this.props.workNo)
    } else if (this.props.vehicleId!==''&&this.props.mode==='tyre-asset-vehicle-doc') {
        let items = {vehicle_id:this.props.vehicleId}
        this.loadData(items)
    }
  }

  componentWillReceiveProps(newProps){
    if(newProps.show&&this.props.show!==newProps.show&&newProps.workNo!==''&&newProps.mode==='tyre-work-doc-entry-view') {
        this.loadInfo(newProps.workNo)
    } else if (newProps.vehicleId!==''&&newProps.mode==='tyre-asset-vehicle-doc') {
        let items = {vehicle_id:newProps.vehicleId}
        this.loadData(items)
    }
  }

  loadInfo(workNo) {
    this.setState({loading:true})
    WorkdocStore.loadAssetWorkInfo(workNo,(result)=>{
        this.setState({loading:false,hasHead:result.data.has_head,hasTail:result.data.has_tail,vehicle:result.data.vehicle,vehicle_id:result.data.vehicle_id})
        this.loadData(result.data.vehicle)
    },()=>{
        this.setState({loading:false}) 
    })    
  }

  loadData(items) {
      this.setState({loading:true})
      TyreStore.loadAssetVehicleTyre(items.vehicle_id,(result)=>{
        if (this.props.mode!=='tyre-work-doc-entry-view'&&this.props.mode!=='tyre-asset-vehicle-doc')
            this.refs.assetVehicleGenForm.onSetFormData(items)
        
        let {treadDepthPartPositions} = this.state
        result.data.forEach((item,index)=>{
            let key = treadDepthPartPositions.findIndex(x=>x.label===item.wheel_at)
            if (key!==-1) {
                treadDepthPartPositions[key].doc.tyre_code = item.tyre_code
                treadDepthPartPositions[key].doc.tyre_brand = item.tyre_brand
                treadDepthPartPositions[key].doc.tyre_model = item.tyre_model===undefined?'':item.tyre_model
                treadDepthPartPositions[key].doc.tyre_size = item.tyre_size
                treadDepthPartPositions[key].doc.treaddepth = item.treaddepth===undefined?'':item.treaddepth
            }
        })
        this.setState({loading:false,data:result.data,formData:items,vehicle_id:items.vehicle_id,treadDepthPartPositions:treadDepthPartPositions})
        this.loadHistoryRecord()
      })
  }

  loadHistoryRecord() {
    let {activeKey,vehicle_id} = this.state
    let key = (activeKey===0?'swap':activeKey===1?'replace':activeKey===2?'':activeKey===3?'treaddepth':activeKey===4?'repair':'')
    if (vehicle_id!==''&&key!=='') {
        this.setState({loading:true})
        TyreStore.loadAssetVehicleRecord(key,vehicle_id,(result)=>{
            this.setState({loading:false,historyRecord:result.data})
        })
    }    
  }

  loadHistoryRecordAt(partId) {
    let {activeKey,vehicle_id} = this.state
    let key = (activeKey===0?'swap':activeKey===1?'replace':activeKey===2?'':activeKey===3?'treaddepth':activeKey===4?'repair':'')
    if (partId!==''&&key!==''&&vehicle_id!=='') {
        this.setState({loading:true})
        TyreStore.loadAssetVehicleRecordByType(key,vehicle_id,partId,(result)=>{
            this.setState({loading:false,historyRecordAt:result.data})
        })
    }    
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onRowSelect(item) {
      this.setState({showTb:false,showOpt:false})
  }

  selectSpot(part_id) {
    let {partPositions} = this.state
    let items = partPositions.find((item,index)=>{
        return item.new_position===part_id&&part_id!==item.label
    })
    if (items!==undefined) {
        this.setState({_partId:items.label})
    } else {
        let key = partPositions.findIndex(x=>x.new_position===part_id)
        if (key===-1)
            this.setState({_partId:''})
    }
    this.setState({showTab:true,showOpt:false,partId:part_id})
    this.loadHistoryRecordAt(part_id)
  }

  getPositionValue(from,to) {
    let {partPositions} = this.state
    let left = partPositions[to-1].style.left
    let _top = partPositions[to-1].style.top.replace('px','')
    let top = (_top*1)+35
    let style = {left:left,top:top+'px'}
    return {label:to,style:style,new_position:from}
  }

  clearPositionByLabel(key) {
    let {partPositions} = this.state
    let label = partPositions[key].label
    partPositions.splice(key,1)

    let labelKey = -1
    partPositions.forEach((item,index)=>{
        if (item.new_position===label)
            labelKey = index
    })
    if (labelKey!==-1)
        partPositions.splice(labelKey,1)
    
    return partPositions    
  }

  clearPositionValue(value) {
    let {partPositions,partId} = this.state
    let key = -1
    partPositions.forEach((item,index)=>{
        if (item.new_position===value)
            key = index
    })
    if (key!==-1) {
        partPositions = this.clearPositionByLabel(key)
    }
    let keyAs = -1
    partPositions.forEach((item,index)=>{
        if (item.new_position===partId)
            keyAs = index
    })
    if (keyAs!==-1) {
        partPositions = this.clearPositionByLabel(keyAs)
    }
    
    this.setState({partPositions:partPositions})
    return true
  }

  onPositionChange(e) {
    let {partId,_partId,partPositions} = this.state
    if (e!==null) {
        _partId = e.value
        if (this.clearPositionValue(_partId)) {
            partPositions.push(this.getPositionValue(partId,_partId))
            partPositions.push(this.getPositionValue(_partId,partId))
        }    
        this.setState({_partId:_partId,partPositions:partPositions})
    } else {
        this.clearPositionValue(_partId)
        this.setState({_partId:''})
    }
  }

  onViewOptClick(){
      let {partPositions,_partPositions,activeMenu,treadDepthPartPositions,data,tyreChangePartPositions,tyreRepairPartPositions} = this.state
      _partPositions = JSON.parse(JSON.stringify(partPositions))
      _partPositions.sort(function(a, b) {
        if(a['label']*1 < b['label']*1) return -1;
        if(a['label']*1 > b['label']*1) return 1;
        return 0;
      })
      this.setState({_partPositions:_partPositions})
      
      setTimeout(()=>{
        this.setState({showOpt:true,showTab:false},()=>{
            this.refs.assetVehicleOperation.setTabActiveKey(activeMenu)
            if (activeMenu==='3') {
                treadDepthPartPositions.forEach((item,index)=>{
                    let key = data.findIndex(x=>x.wheel_at===item.label)
                    if (key!==-1) {
                        item.doc.tyre_code = data[key].tyre_code
                        item.doc.tyre_brand = data[key].tyre_brand
                        item.doc.tyre_model = data[key].tyre_model===undefined?'':data[key].tyre_model
                        item.doc.tyre_size = data[key].tyre_size
                        item.doc.treaddepth = data[key].treaddepth===undefined?'':data[key].treaddepth
                    }
                })
                this.refs.assetVehicleOperation.setTreadDepth(treadDepthPartPositions)
            } else if (activeMenu==='1') {
                tyreChangePartPositions.forEach((item,index)=>{
                    let key = data.findIndex(x=>x.wheel_at===item.label)
                    if (key!==-1) {
                        item.doc.tyre_code = data[key].tyre_code
                        item.doc.tyre_brand = data[key].tyre_brand
                        item.doc.tyre_model = data[key].tyre_model===undefined?'':data[key].tyre_model
                        item.doc.tyre_size = data[key].tyre_size
                        item.doc.is_new = data[key].is_new
                    }
                })
                this.refs.assetVehicleOperation.setTyreChange(tyreChangePartPositions)
            } else if (activeMenu==='4') {
                tyreRepairPartPositions.forEach((item,index)=>{
                    let key = data.findIndex(x=>x.wheel_at===item.label)
                    if (key!==-1) {
                        item.doc.tyre_code = data[key].tyre_code
                        item.doc.tyre_brand = data[key].tyre_brand
                        item.doc.tyre_model = data[key].tyre_model===undefined?'':data[key].tyre_model
                        item.doc.description = data[key].description===undefined?'':data[key].description
                        item.doc.tyre_size = data[key].tyre_size
                        item.doc.shop_name = data[key].shop_name===undefined?'':data[key].shop_name
                    }
                })
                this.refs.assetVehicleOperation.setTyreRepair(tyreRepairPartPositions)
            }   
        })
      },100)
  }

  onNormalModeClick() {
    let {partId} = this.state
    if (partId!=='')
        this.loadHistoryRecordAt(partId)
    else    
        this.loadHistoryRecord()
    this.setState({partPositions:JSON.parse(JSON.stringify(DEFAULT_PART_POSITIONS)),_partPositions:JSON.parse(JSON.stringify(DEFAULT_PART_POSITIONS)),treadDepthPartPositions:JSON.parse(JSON.stringify(DEFAULT_TREAD_DEPTH_PART_POSITIONS)),tyreChangePartPositions:JSON.parse(JSON.stringify(DEFAULT_TREAD_DEPTH_PART_POSITIONS)),tyreRepairPartPositions:JSON.parse(JSON.stringify(DEFAULT_TREAD_DEPTH_PART_POSITIONS))})
    setTimeout(()=>{
        this.setState({activeMenu:undefined,showOpt:false,showTab:true})
    },100)
  }

  onReload() {
    let {formData,vehicle_id} = this.state
    let {mode} = this.props
    if (mode==='tyre-work-doc-entry-view') {
        this.loadData(formData)
    } else if (mode==='tyre-asset-vehicle-doc') {
        let items = {vehicle_id:vehicle_id}
        this.loadData(items)
    }
  }

  onTreadDepthChange(item) {
    let {treadDepthPartPositions} = this.state
    let key = treadDepthPartPositions.findIndex(x=>x.label===item.index)
    if (key!==-1) {
        treadDepthPartPositions[key].doc[item.field] = item.value
        this.setState({treadDepthPartPositions:treadDepthPartPositions})
    }    
  }

  onTyreChangeTextChange(item) {
    let {tyreChangePartPositions} = this.state
    let key = tyreChangePartPositions.findIndex(x=>x.label===item.index)
    if (key!==-1) {
        tyreChangePartPositions[key].doc[item.field] = item.value
        this.setState({tyreChangePartPositions:tyreChangePartPositions})
    }    
  }

  onTyreRepairTextChange(item) {
    let {tyreRepairPartPositions} = this.state
    let key = tyreRepairPartPositions.findIndex(x=>x.label===item.index)
    if (key!==-1) {
        tyreRepairPartPositions[key].doc[item.field] = item.value
        this.setState({tyreRepairPartPositions:tyreRepairPartPositions})
    }    
  }

  onTreadDepthPartClick(index) {
    let {treadDepthPartPositions,data} = this.state
    if (treadDepthPartPositions[index].status) {
        treadDepthPartPositions[index].status = false
        treadDepthPartPositions[index].doc = {wheel_at:'',tyre_code:'',tyre_brand:'',tyre_model:'',tyre_size:'',treaddepth:''}
    } else {
        treadDepthPartPositions[index].status = true
        let key = data.findIndex(x=>x.wheel_at===treadDepthPartPositions[index].label)
        if (key!==-1) {
            treadDepthPartPositions[index].doc.tyre_code = data[key].tyre_code
            treadDepthPartPositions[index].doc.tyre_brand = data[key].tyre_brand
            treadDepthPartPositions[index].doc.tyre_model = data[key].tyre_model===undefined?'':data[key].tyre_model
            treadDepthPartPositions[index].doc.tyre_size = data[key].tyre_size
            treadDepthPartPositions[index].doc.treaddepth = data[key].treaddepth===undefined?'':data[key].treaddepth
        }
    }    
    this.setState({treadDepthPartPositions:treadDepthPartPositions})      
    this.refs.assetVehicleOperation.setTreadDepth(treadDepthPartPositions)  
  }

  onTyreChangePartClick(index) {
    let {tyreChangePartPositions,data} = this.state
    if (tyreChangePartPositions[index].status) {
        tyreChangePartPositions[index].status = false
        tyreChangePartPositions[index].doc = {wheel_at:'',tyre_code:'',tyre_brand:'',tyre_model:'',tyre_size:'',is_new:''}
    } else {
        tyreChangePartPositions[index].status = true
        let key = data.findIndex(x=>x.wheel_at===tyreChangePartPositions[index].label)
        if (key!==-1) {
            tyreChangePartPositions[index].doc.tyre_code = data[key].tyre_code
            tyreChangePartPositions[index].doc.tyre_brand = data[key].tyre_brand
            tyreChangePartPositions[index].doc.tyre_model = data[key].tyre_model===undefined?'':data[key].tyre_model
            tyreChangePartPositions[index].doc.tyre_size = data[key].tyre_size
            tyreChangePartPositions[index].doc.is_new = data[key].is_new
        }
    }    
    this.setState({tyreChangePartPositions:tyreChangePartPositions})      
    this.refs.assetVehicleOperation.setTyreChange(tyreChangePartPositions)
  }

  onTyreRepairPartClick(index) {
    let {tyreRepairPartPositions,data} = this.state
    if (tyreRepairPartPositions[index].status) {
        tyreRepairPartPositions[index].status = false
        tyreRepairPartPositions[index].doc = {wheel_at:'',tyre_code:'',tyre_brand:'',tyre_size:'',description:'',shop_name:''}
    } else {
        tyreRepairPartPositions[index].status = true
        let key = data.findIndex(x=>x.wheel_at===tyreRepairPartPositions[index].label)
        if (key!==-1) {
            tyreRepairPartPositions[index].doc.tyre_code = data[key].tyre_code
            tyreRepairPartPositions[index].doc.tyre_brand = data[key].tyre_brand
            tyreRepairPartPositions[index].doc.description = data[key].description===undefined?'':data[key].description
            tyreRepairPartPositions[index].doc.tyre_size = data[key].tyre_size
            tyreRepairPartPositions[index].doc.shop_name = data[key].shop_name===undefined?'':data[key].shop_name
        }
    }    
    this.setState({tyreRepairPartPositions:tyreRepairPartPositions})      
    this.refs.assetVehicleOperation.setTyreRepair(tyreRepairPartPositions)
  }

  onTreadDepthDel(wheel_at) {
    let {treadDepthPartPositions} = this.state
    let index = treadDepthPartPositions.findIndex(x=>x.label===wheel_at)
    if (index!==-1) {
        treadDepthPartPositions[index].status = false
        treadDepthPartPositions[index].doc = {wheel_at:'',tyre_code:'',tyre_brand:'',tyre_model:'',tyre_size:'',treaddepth:''}
        this.setState({treadDepthPartPositions:treadDepthPartPositions})      
        this.refs.assetVehicleOperation.setTreadDepth(treadDepthPartPositions) 
    }    
  }

  onTyreChangeDel(wheel_at) {
    let {tyreChangePartPositions} = this.state
    let index = tyreChangePartPositions.findIndex(x=>x.label===wheel_at)
    if (index!==-1) {
        tyreChangePartPositions[index].status = false
        tyreChangePartPositions[index].doc = {wheel_at:'',tyre_code:'',tyre_brand:'',tyre_model:'',tyre_size:'',is_new:''}
        this.setState({tyreChangePartPositions:tyreChangePartPositions})      
        this.refs.assetVehicleOperation.setTyreChange(tyreChangePartPositions) 
    }    
  }

  onTyreRepairDel(wheel_at) {
    let {tyreRepairPartPositions} = this.state
    let index = tyreRepairPartPositions.findIndex(x=>x.label===wheel_at)
    if (index!==-1) {
        tyreRepairPartPositions[index].status = false
        tyreRepairPartPositions[index].doc = {wheel_at:'',tyre_code:'',tyre_brand:'',description:'',tyre_size:'',shop_name:''}
        this.setState({tyreRepairPartPositions:tyreRepairPartPositions})      
        this.refs.assetVehicleOperation.setTyreRepair(tyreRepairPartPositions) 
    }    
  }

  onHistoryRowClick(item,type) {
    let {activeMenu} = this.state
    this.setState({showTab:false,showOpt:true,loading:true})
    TyreStore.loadAssetVehicleHistory(type,item.tyre_record_id,(result)=>{
        activeMenu = (type==='swap'?'0':type==='replace'?'1':type==='repair'?'4':type==='treaddepth'?'3':'')
        this.setState({loading:false,activeMenu:activeMenu})
        this.refs.assetVehicleOperation.setTabActiveKey(activeMenu)
        setTimeout(()=>{
            this.refs.assetVehicleOperation.setIsView(type,result.data)
        },100)
    })
  }

  renderRowData() {
      let {data} = this.state
      if (data.length===0) {
          return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
      } else {
          return(
            data.map((item,index)=>
                <tr key={index}>
                    <td className='text-center'>{item.wheel_at}</td>
                    <td className='text-center'>{item.serial_no}</td>
                    <td className='text-center'>{item.tyre_brand}</td>
                    <td className='text-center'>{item.tyre_model}</td>
                    <td className='text-center'>{(item.is_new==='1'?<FontAwesome name='check' />:'')}</td>
                    <td className='text-center'>{''}</td>
                    <td className='text-center'>{item.tyre_size}</td>
                    <td className='text-center'>{this.getNumberFormat(item.tyre_mileage)}</td>
                </tr>
            )
          )
      }
  }

  renderTable() {
      return(
          <div className='table-responsive' style={{marginTop:'10px'}}>
            <table className='table table-bordered-solid table-hover'>
                <thead>
                    <tr>
                        <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ตำแหน่ง</th>
                        <th className='text-center' style={{minWidth:'80px',width:'80px'}}>หมายเลขยาง</th>
                        <th className='text-center' style={{minWidth:'110px',width:'110px'}}>ยี่ห้อ</th>
                        <th className='text-center' style={{minWidth:'120px',width:'120px'}}>รุ่น</th>
                        <th className='text-center' style={{minWidth:'60px',width:'60px'}}>ใหม่</th>
                        <th className='text-center' style={{minWidth:'60px',width:'60px'}}>หล่อดอก</th>
                        <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ขนาด</th>
                        <th className='text-center' style={{minWidth:'120px',width:'120px'}}>เลขไมล์</th>
                    </tr>    
                </thead>
                <tbody>
                    {this.renderRowData()}
                </tbody>        
            </table>
          </div>
      )
  }

  renderCarModel() {
        let {partPositions,partId,hasHead,hasTail} = this.state
        return(
            <div id={'vehicle-damage-layout'}>
                <div id="container" className='text-right'>
                    <img alt='' id="vehicle_body_canvas" src={IMG} />
                    {
                        partPositions.map((item, index) => {
                            let label = (item.new_position!==false?item.new_position:item.label);
                            let disabled = '';
                            if(HEAD_LIST.includes(label*1)){
                                disabled = hasHead?'':'disabled ';
                            }else if(TAIL_LIST.includes(label*1)){
                                disabled = hasTail?'':'disabled ';
                            }
                            let click = ()=>{};
                            if(item.new_position!==false){
                                
                            }else{
                                click = this.selectSpot.bind(this,label);
                            }
                            if(disabled!==''){
                                click = ()=>{};
                            }
                            return (
                                <div 
                                    key={index}
                                    className={disabled+(item.new_position!==false?'new-position':'')+' damage-spot-circle '+(partId===label?'active':'')}
                                    onClick={click}
                                    style={item.style}
                                >
                                    {label}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        )
  }

  renderTreadDepthCarModel() {
    let {treadDepthPartPositions,hasHead,hasTail} = this.state
    return(
        <div id={'vehicle-damage-layout'}>
            <div id="container" className='text-right'>
                <img alt='' id="vehicle_body_canvas" src={IMG} />
                {
                    treadDepthPartPositions.map((item, index) => {
                        let disabled = '';
                        if(HEAD_LIST.includes(item.label*1)){
                            disabled = hasHead?'':'disabled ';
                        }else if(TAIL_LIST.includes(item.label*1)){
                            disabled = hasTail?'':'disabled ';
                        }
                        let click = this.onTreadDepthPartClick.bind(this,index)
                        if(disabled!==''){
                            click = ()=>{};
                        }
                        return (
                            <div 
                                key={index}
                                className={disabled+' damage-spot-circle'+(item.status?' active':'')}
                                onClick={click}
                                style={item.style}
                            >
                                {item.label}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
  }

  tyreChangeCarModel() {
    let {tyreChangePartPositions,hasHead,hasTail} = this.state
    return(
        <div id={'vehicle-damage-layout'}>
            <div id="container" className='text-right'>
                <img alt='' id="vehicle_body_canvas" src={IMG} />
                {
                    tyreChangePartPositions.map((item, index) => {
                        let disabled = '';
                        if(HEAD_LIST.includes(item.label*1)){
                            disabled = hasHead?'':'disabled ';
                        }else if(TAIL_LIST.includes(item.label*1)){
                            disabled = hasTail?'':'disabled ';
                        }
                        let click = this.onTyreChangePartClick.bind(this,index)
                        if(disabled!==''){
                            click = ()=>{};
                        }
                        return (
                            <div 
                                key={index}
                                className={disabled+' damage-spot-circle'+(item.status?' active':'')}
                                onClick={click}
                                style={item.style}
                            >
                                {item.label}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
  }

  tyreRepairCarModel() {
    let {tyreRepairPartPositions,hasHead,hasTail} = this.state
    return(
        <div id={'vehicle-damage-layout'}>
            <div id="container" className='text-right'>
                <img alt='' id="vehicle_body_canvas" src={IMG} />
                {
                    tyreRepairPartPositions.map((item, index) => {
                        let disabled = '';
                        if(HEAD_LIST.includes(item.label*1)){
                            disabled = hasHead?'':'disabled ';
                        }else if(TAIL_LIST.includes(item.label*1)){
                            disabled = hasTail?'':'disabled ';
                        }
                        let click = this.onTyreRepairPartClick.bind(this,index)
                        if(disabled!==''){
                            click = ()=>{};
                        }
                        return (
                            <div 
                                key={index}
                                className={disabled+' damage-spot-circle'+(item.status?' active':'')}
                                onClick={click}
                                style={item.style}
                            >
                                {item.label}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
  }

  renderHistoryRowData(type,data) {
      if (data.length===0) {
          return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
      } else {
          return(
            data.map((item,index)=>{
                return(
                    <tr key={index} onClick={this.onHistoryRowClick.bind(this,item,type)}>
                        <td className='text-center'>{item.record_date}</td>
                        <td className='text-center'>{item.record_time}</td>
                        <td className='text-center'>{item.request_by}</td>
                        <td className='text-center'>{item.response_by}</td>
                        <td className='text-left'>{item.description}</td>
                    </tr>
                )
            })
          )
      }
  }

  renderHistoryAtRowData(data) {
    if (data.length===0) {
        return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
          data.map((item,index)=>{
              return(
                  <tr key={index}>
                      <td className='text-center'>{item.record_date}</td>
                      <td className='text-center'>{item.record_time}</td>
                      <td className='text-center'>{item.tyre_brand}</td>
                      <td className='text-center'>{item.tyre_size}</td>
                      <td className='text-center'>{item.tyre_size}</td>
                      <td className='text-center'>{this.getNumberFormat(item.tyre_mileage)}</td>
                      <td className='text-center'>{item.request_by}</td>
                  </tr>
              )
          })
        )
    }
}

  onTabsSelect(e) {
    this.setState({activeKey:e})
    let {partId} = this.state
    setTimeout(()=>{
        if (partId==='')
            this.loadHistoryRecord()
        else
            this.loadHistoryRecordAt(partId)    
    },100)
  }

  onBack() {
    this.setState({partId:'',_partId:'',partPositions:JSON.parse(JSON.stringify(DEFAULT_PART_POSITIONS)),_partPositions:JSON.parse(JSON.stringify(DEFAULT_PART_POSITIONS))})
    setTimeout(()=>{
        this.loadHistoryRecord()
    },100)
  }

  renderTab() {
    let {activeKey,showTab,activeMenu} = this.state
    return(
      <div style={{display:(showTab?'':'none')}}>  
          <Tabs 
              id='tabs-asset-vehicle'
              defaultActiveKey={0}
              activeKey={activeKey}
              onSelect={this.onTabsSelect.bind(this)}
          >   
              {activeMenu==='0'||activeMenu===undefined
              ?
              <Tab
                  key={0}
                  eventKey={0} 
                  title={'สลับยาง'}
              >
                  {this.renderTab1()}
              </Tab>
              :''}
              {activeMenu==='1'||activeMenu===undefined
              ?
              <Tab 
                  key={1}
                  eventKey={1} 
                  title={'เปลี่ยนยาง'}
              >
                  {this.renderTab2()}
              </Tab>
              :''}
              {activeMenu==='4'||activeMenu===undefined
              ?
              <Tab 
                  key={4}
                  eventKey={4} 
                  title={'ซ่อมยาง'}
              >
                  {this.renderTab5()}
              </Tab>
              :''}
              {/* {activeMenu==='2'||activeMenu===undefined
              ?
              <Tab 
                  key={2}
                  eventKey={2} 
                  title={'หล่อดอก'}
              >
                  {this.renderTab3()}
              </Tab>
              :''} */}
              {activeMenu==='3'||activeMenu===undefined
              ?
              <Tab 
                  key={3}
                  eventKey={3} 
                  title={'วัดดอกยาง'}
              >
                  {this.renderTab4()}
              </Tab>
              :''}
          </Tabs>
      </div>    
    )
  }

  renderHistoryTable(type,data,dataAt) {
    let {partId} = this.state
    return(
                        <table className='table table-bordered-solid table-hover'>
                            <thead>
                                {partId!==''
                                ?
                                <tr>
                                    <th className='text-center' style={{minWidth:'80px',width:'80px'}}>วันที่</th>
                                    <th className='text-center' style={{minWidth:'80px',width:'80px'}}>เวลา</th>    
                                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ยี่ห้อยาง</th>
                                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>เบอร์ยาง</th>
                                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ขนาด</th>
                                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>เลขไมค์</th>
                                    <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ดำเนินการ</th>
                                </tr>
                                :
                                <tr>
                                    <th className='text-center' style={{minWidth:'80px',width:'80px'}}>วันที่</th>    
                                    <th className='text-center' style={{minWidth:'80px',width:'80px'}}>เวลา</th>
                                    <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ผู้ขอดำเนินการ</th>
                                    <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ผู้อนุมัติ</th>
                                    <th className='text-center' style={{minWidth:'120px',width:'120px'}}>คำอธิบาย</th>
                                </tr>
                                }
                            </thead>
                            <tbody>
                                {partId!==''
                                ?
                                this.renderHistoryAtRowData(dataAt)
                                :
                                this.renderHistoryRowData(type,data)
                                }
                            </tbody>
                        </table>
    )
  }

  getLabelOptions(wheel_at) {
    let {data} = this.state
    let {messages} = this.props
    let label = ''
    let key = data.findIndex(x=>x.wheel_at===wheel_at)
    let _wheel_at = wheel_at==='1'?'-'+messages['Left Front']+' ':wheel_at==='2'?'-'+messages['Right Front']+' ':wheel_at==='3'||wheel_at==='7'?'-'+messages['Left Front Outside']+' ':wheel_at==='4'||wheel_at==='8'?'-'+messages['Left Front Inside']+' ':wheel_at==='5'||wheel_at==='9'?'-'+messages['Right Front Inside']+' ':wheel_at==='6'||wheel_at==='10'?'-'+messages['Right Front Outside']+' ':wheel_at==='11'||wheel_at==='15'||wheel_at==='19'?'-'+messages['Left Rear Outside']+' ':wheel_at==='12'||wheel_at==='16'||wheel_at==='20'?'-'+messages['Left Rear Inside']+' ':wheel_at==='13'||wheel_at==='17'||wheel_at==='21'?'-'+messages['Right Rear Inside']+' ':wheel_at==='14'||wheel_at==='18'||wheel_at==='22'?'-'+messages['Right Rear Outside']+' ':''
    if (key!==-1) {
        label = wheel_at+_wheel_at+' - '+(data[key].serial_no===''||data[key].serial_no===null||data[key].serial_no===undefined?'???':data[key].serial_no)+' - '+(data[key].tyre_brand===''||data[key].tyre_brand===null||data[key].tyre_brand===undefined?'???':data[key].tyre_brand)+' - '+(data[key].tyre_model===''||data[key].tyre_model===null||data[key].tyre_model===undefined?'???':data[key].tyre_model)
    } else {
        label = wheel_at+_wheel_at
    }
    return label
  }

  renderTab1() {
      let {_partId,partId,activeMenu} = this.state
      let options = [
          {label:this.getLabelOptions('1'),value:'1',disabled:(partId==='1'?true:false)},
          {label:this.getLabelOptions('2'),value:'2',disabled:(partId==='2'?true:false)},
          {label:this.getLabelOptions('3'),value:'3',disabled:(partId==='3'?true:false)},
          {label:this.getLabelOptions('4'),value:'4',disabled:(partId==='4'?true:false)},
          {label:this.getLabelOptions('5'),value:'5',disabled:(partId==='5'?true:false)},
          {label:this.getLabelOptions('6'),value:'6',disabled:(partId==='6'?true:false)},
          {label:this.getLabelOptions('7'),value:'7',disabled:(partId==='7'?true:false)},
          {label:this.getLabelOptions('8'),value:'8',disabled:(partId==='8'?true:false)},
          {label:this.getLabelOptions('9'),value:'9',disabled:(partId==='9'?true:false)},
          {label:this.getLabelOptions('10'),value:'10',disabled:(partId==='10'?true:false)},
          {label:this.getLabelOptions('11'),value:'11',disabled:(partId==='11'?true:false)},
          {label:this.getLabelOptions('12'),value:'12',disabled:(partId==='12'?true:false)},
          {label:this.getLabelOptions('13'),value:'13',disabled:(partId==='13'?true:false)},
          {label:this.getLabelOptions('14'),value:'14',disabled:(partId==='14'?true:false)},
          {label:this.getLabelOptions('15'),value:'15',disabled:(partId==='15'?true:false)},
          {label:this.getLabelOptions('16'),value:'16',disabled:(partId==='16'?true:false)},
          {label:this.getLabelOptions('17'),value:'17',disabled:(partId==='17'?true:false)},
          {label:this.getLabelOptions('18'),value:'18',disabled:(partId==='18'?true:false)},
          {label:this.getLabelOptions('19'),value:'19',disabled:(partId==='19'?true:false)},
          {label:this.getLabelOptions('20'),value:'20',disabled:(partId==='20'?true:false)},
          {label:this.getLabelOptions('21'),value:'21',disabled:(partId==='21'?true:false)},
          {label:this.getLabelOptions('22'),value:'22',disabled:(partId==='22'?true:false)}
      ]
      if(activeMenu==='0')
      return(
        <Box>            
            <Box.Body>                
                <Row>
                    <Col sm={3}>
                        <div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div> สลับไปยังตำแหน่ง
                    </Col>
                    <Col sm={3}>
                        <Select
                            className='width-menu-outer'
                            searchable={false}
                            placeholder={'เลือกตำแหน่ง'}
                            clearable={true}
                            value={_partId}
                            options={options}
                            onChange={this.onPositionChange.bind(this)}
                        />
                    </Col>
                    <Col sm={2}>
                        <Button onClick={this.onViewOptClick.bind(this)}><FontAwesome name='bullseye'/> ดูหน้ารวม</Button>
                    </Col>
                </Row>                
            </Box.Body>    
        </Box>    
      )
      else if (activeMenu===undefined) 
        return this.renderSwapHistory(partId)
      else return ('');
  }

  renderSwapHistory(partId){
      const {showNewItem} = this.props
      return (
        <Box loading={false} border={false}>
            <Box.Header>
                <Box.Title>ประวัติการสลับยาง {partId!==''?<div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div>:''}</Box.Title>
                {showNewItem && (<Box.Tools>
                    <Button                
                        bsStyle={'link'} 
                        className='text-large'
                        onClick={this.onMenuItemSelect.bind(this,"0")}
                    >
                        <FontAwesome name='plus' /> เพิ่มรายการ
                    </Button>
                </Box.Tools>)}
            </Box.Header>
            <Box.Body>
                <Row>
                    <Col md={12}>
                        {this.renderHistoryTable('swap',this.state.historyRecord,this.state.historyRecordAt)}
                    </Col>
                </Row>
            </Box.Body>
            {partId!==''?
            <Box.Footer>
                <ButtonToolbar className='pull-right'>    
                    <Button onClick={this.onBack.bind(this)}></Button>
                </ButtonToolbar>
            </Box.Footer>
            :''}
        </Box>
      )
  }

  renderTab2() {
    let {partId,activeMenu} = this.state
    const {showNewItem} = this.props
    if(activeMenu===undefined)
    return(
        <Box>
            <Box.Header>
                <Box.Title>ประวัติการเปลี่ยนยาง {partId!==''?<div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div>:''}</Box.Title>
                {showNewItem && (<Box.Tools>
                    <Button                
                        bsStyle={'link'} 
                        className='text-large'
                        onClick={this.onMenuItemSelect.bind(this,"1")}
                    >
                        <FontAwesome name='plus' /> เพิ่มรายการ
                    </Button>
                </Box.Tools>)}
            </Box.Header>
            <Box.Body>                           
                <Row>
                    <Col md={12}>
                        {this.renderHistoryTable('replace',this.state.historyRecord,this.state.historyRecordAt)}
                    </Col>
                </Row>                
            </Box.Body>  
            {partId!==''?
            <Box.Footer>
                <ButtonToolbar className='pull-right'>    
                    <Button onClick={this.onBack.bind(this)}><FontAwesome name='table'/>&nbsp;กลับหน้าประวัติบันทึกข้อมูล</Button>
                </ButtonToolbar>
            </Box.Footer>
            :''}  
        </Box>    
    )
    else{
        return ('')
    }
  }

//   renderTab3(){
//     let {_partId,partId,activeMenu} = this.state
//       return (
//         <Box>
//             <Box.Body>
//                 {activeMenu==='2'
//                 ?
//                 <Row>
//                     <Col sm={3}>
//                         <div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div>&nbsp;
//                         <Button><FontAwesome name='plus'/> นำยางไปหล่อดอก</Button>
//                     </Col>
//                     <Col sm={2}>
//                         <Button onClick={this.onViewOptClick.bind(this)}><FontAwesome name='bullseye'/> ดูหน้ารวม</Button>
//                     </Col>
//                 </Row>
//                 :''}
//                 {activeMenu===undefined
//                 ?
//                 <Row style={{marginTop:'10px'}}>
//                     <Col md={12}>
//                         ประวัติการหล่อดอก {partId!==''?<div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div>:''}
//                     </Col>                    
//                 </Row>
//                 :''}
//                 {activeMenu===undefined
//                 ?
//                 <Row>
//                     <Col md={12}>
//                         <table className='table table-bordered-solid table-hover'>
//                             <thead>
//                                 <tr>
//                                     <th className='text-center' style={{minWidth:'80px',width:'80px'}}>วันที่</th>    
//                                     <th className='text-center' style={{minWidth:'80px',width:'80px'}}>เวลา</th>
//                                     <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ดำเนินการ</th>
//                                     <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ผู้อนุมัติ</th>
//                                     <th className='text-center' style={{minWidth:'120px',width:'120px'}}>คำอธิบาย</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>
//                             </tbody>
//                         </table>
//                     </Col>
//                 </Row>
//                 :''}
//             </Box.Body>    
//         </Box>    
//       )
//   }

  renderTab4() {
    let {partId,activeMenu} = this.state
    const {showNewItem} = this.props
    if(activeMenu===undefined)
    return(
        <Box>
            <Box.Header>
                <Box.Title>ประวัติการวัดดอกยาง {partId!==''?<div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div>:''}</Box.Title>
                {showNewItem && (<Box.Tools>
                    <Button                
                        bsStyle={'link'} 
                        className='text-large'
                        onClick={this.onMenuItemSelect.bind(this,"3")}
                    >
                        <FontAwesome name='plus' /> เพิ่มรายการ
                    </Button>
                </Box.Tools>)}
            </Box.Header>
            <Box.Body>
                <Row>
                    <Col md={12}>
                        {this.renderHistoryTable('treaddepth',this.state.historyRecord,this.state.historyRecordAt)}
                    </Col>
                </Row>
            </Box.Body>    
            {partId!==''?
            <Box.Footer>
                <ButtonToolbar className='pull-right'>    
                    <Button onClick={this.onBack.bind(this)}><FontAwesome name='table'/>&nbsp;กลับหน้าประวัติบันทึกข้อมูล</Button>
                </ButtonToolbar>
            </Box.Footer>
            :''}
        </Box>    
    )
    else {
        return ('')
    }
  }

  renderTab5() {
    let {partId,activeMenu} = this.state
    const {showNewItem} = this.props
    if(activeMenu===undefined)
    return(
        <Box>
            <Box.Header>
                <Box.Title>ประวัติการซ่อมยาง {partId!==''?<div style={{display:'inline-block'}} className='damage-spot-circle'>{partId}</div>:''}</Box.Title>
                {showNewItem && ( <Box.Tools>
                    <Button                
                        bsStyle={'link'} 
                        className='text-large'
                        onClick={this.onMenuItemSelect.bind(this,"4")}
                    >
                        <FontAwesome name='plus' /> เพิ่มรายการ
                    </Button>
                </Box.Tools>)}
            </Box.Header>
            <Box.Body>
                <Row>
                    <Col md={12}>
                        {this.renderHistoryTable('repair',this.state.historyRecord,this.state.historyRecordAt)}
                    </Col>
                </Row>
            </Box.Body> 
            {partId!==''?
            <Box.Footer>
                <ButtonToolbar className='pull-right'>    
                    <Button onClick={this.onBack.bind(this)}><FontAwesome name='table'/>&nbsp;กลับหน้าประวัติบันทึกข้อมูล</Button>
                </ButtonToolbar>
            </Box.Footer>
            :''}   
        </Box>    
    )
    else{
        return ('')
    }
  }

  renderOperation(){
    let {showOpt,_partPositions,data,vehicle_id,activeMenu,treadDepthPartPositions,hasHead,hasTail} = this.state
    let {workNo} = this.props
      return (
        <div style={{display:(showOpt?'':'none')}}>  
            <AssetVehicleOperation 
                ref='assetVehicleOperation'
                vehicle_id={vehicle_id}
                work_no={workNo}
                hasHead={hasHead}
                hasTail={hasTail}
                showOpt={showOpt}
                partPositions={_partPositions}
                treadDepthPartPositions={treadDepthPartPositions}
                data={data}
                menu={activeMenu}
                mode={activeMenu==='0'?'สลับยาง':activeMenu==='1'?'เปลี่ยนยาง':activeMenu==='2'?'หล่อดอก':activeMenu==='3'?'วัดดอกยาง':activeMenu==='4'?'ซ่อมยาง':''}
                normalMode={this.onNormalModeClick.bind(this)}
                onReload={this.onReload.bind(this)}
                onTreadDepthChange={this.onTreadDepthChange.bind(this)}
                onTyreChangeTextChange={this.onTyreChangeTextChange.bind(this)}
                onTyreRepairTextChange={this.onTyreRepairTextChange.bind(this)}
                onTreadDepthDel={this.onTreadDepthDel.bind(this)}
                onTyreChangeDel={this.onTyreChangeDel.bind(this)}
                onTyreRepairDel={this.onTyreRepairDel.bind(this)}
            />
        </div>
      )
  }

    onAfterSave(formData) {
        this.setState({formData:formData})
    }

    onMenuItemSelect(key) {
        let {activeMenu,partId,treadDepthPartPositions,tyreChangePartPositions,tyreRepairPartPositions} = this.state
        if (key==='delete-car') {
            this.setState({showConfirmDel:true})
        } else {
            if (activeMenu===undefined||activeMenu===key) {
                this.setState({activeMenu:key,activeKey:key*1})
                if (key==='0'||key==='3'||key==='1'||key==='4') {
                    setTimeout(()=>{
                        this.onViewOptClick()
                        if (key==='3'&&partId!=='') {
                            let index = treadDepthPartPositions.findIndex(x=>x.label===partId)
                            if (index!==-1) {
                                treadDepthPartPositions[index].status = true
                                this.setState({treadDepthPartPositions:treadDepthPartPositions})
                            }
                        } else if (key==='1'&&partId!=='') {
                            let index = tyreChangePartPositions.findIndex(x=>x.label===partId)
                            if (index!==-1) {
                                tyreChangePartPositions[index].status = true
                                this.setState({tyreChangePartPositions:tyreChangePartPositions})
                            }
                        } else if (key==='4'&&partId!=='') {
                            let index = tyreRepairPartPositions.findIndex(x=>x.label===partId)
                            if (index!==-1) {
                                tyreRepairPartPositions[index].status = true
                                this.setState({tyreRepairPartPositions:tyreRepairPartPositions})
                            }
                        }
                    },100)
                }
            } else {
                this.setState({showModeChange:true,_activeMenu:key})
            }
        }
    }

    onCarConfirmDel() {
        let {vehicle_id} = this.state
        TyreStore.delAssetVehicle(vehicle_id,(result)=>{
            if (result.status==='OK') {
                this.setState({vehicle_id:'',showConfirmDel:false})
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message: 'ทำรายการลบรถคันนี้ทิ้งถาวรสำเร็จ',
                    level: 'info',
                    position:'tc'
                });

                setTimeout(()=>{
                    if (this.props.onClose!==undefined)
                        this.props.onClose()
                },1000)
            }
        },()=>{
            this.setState({showConfirmDel:false})
            this._notificationSystem.addNotification({
                title:'แจ้งเตือน',
                message: 'ไม่สามารถทำรายการลบรถคันนี้ทิ้งถาวรได้',
                level: 'error',
                position:'tc'
            });
        })
    }

    onModeChangeConfirmClick() {
        let {_activeMenu,partId,treadDepthPartPositions,tyreChangePartPositions,tyreRepairPartPositions} = this.state
        let key = JSON.parse(JSON.stringify(_activeMenu))
        this.setState({activeMenu:key,activeKey:key*1,showModeChange:false,_activeMenu:undefined,showTab:true,showOpt:false})
        if (key==='0'||key==='3'||key==='1'||key==='4') {
            setTimeout(()=>{
                this.onViewOptClick()
                if (key==='3'&&partId!=='') {
                    let index = treadDepthPartPositions.findIndex(x=>x.label===partId)
                    if (index!==-1) {
                        treadDepthPartPositions[index].status = true
                        this.setState({treadDepthPartPositions:treadDepthPartPositions})
                    }
                } else if (key==='1'&&partId!=='') {
                    let index = tyreChangePartPositions.findIndex(x=>x.label===partId)
                    if (index!==-1) {
                        tyreChangePartPositions[index].status = true
                        this.setState({tyreChangePartPositions:tyreChangePartPositions})
                    }
                } else if (key==='4'&&partId!=='') {
                    let index = tyreRepairPartPositions.findIndex(x=>x.label===partId)
                    if (index!==-1) {
                        tyreRepairPartPositions[index].status = true
                        this.setState({tyreRepairPartPositions:tyreRepairPartPositions})
                    }
                }
            },100)
        }
    }

    onCheckboxChange(field){
        let state = this.state
        state[field] = !this.state[field]
        this.setState(state)
    }

  renderGenForm() {
    let {vehicle_id} = this.state
    return(
        <AssetVehicleGenForm
            ref='assetVehicleGenForm'
            vehicleId={vehicle_id}
            onAfterSave={this.onAfterSave.bind(this)}
        />
    )
  }

  renderVehicleTypeSelection(){
      const {hasHead,hasTail} = this.state
      return (
        <Form inline>
            <FormGroup>
                <Checkbox
                    onChange={this.onCheckboxChange.bind(this,'hasHead')}
                    checked={hasHead}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=" ส่วนหัว"
                />
            </FormGroup>
            {' '}
            <FormGroup>
                <Checkbox
                    onChange={this.onCheckboxChange.bind(this,'hasTail')}
                    checked={hasTail}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label=" ส่วนหาง"
                />             
            </FormGroup>
        </Form>
      )
  }

  render() {
    let {loading,activeMenu,_activeMenu} = this.state
    let {mode} = this.props
    let title = (<span><FontAwesome name='list' />&nbsp;เมนู</span>)
    return(
    	<div>
            <div>
                <Box loading={loading}>
                    <Box.Header border={true}>
                        <Box.Title>{'ตารางรายงานยางยานพาหนะ'+(activeMenu==='0'?' [โหมดสลับยาง]':activeMenu==='1'?' [โหมดเปลี่ยนยาง]':activeMenu==='2'?' [โหมดหล่อดอก]':activeMenu==='3'?' [โหมดวัดดอกยาง]':activeMenu==='4'?' [โหมดซ่อมยาง]':'')}</Box.Title>
                        {false&& (<Box.Tools className='pull-right' >
                            <DropdownButton bsStyle={'primary'} title={title} id={'asset-vehicle-options'} onSelect={this.onMenuItemSelect.bind(this)}>
                                <MenuItem eventKey="0"><FontAwesome name='bullseye' className='text-black' />&nbsp;สลับยาง</MenuItem>
                                <MenuItem eventKey="1"><FontAwesome name='bullseye' className='text-black' />&nbsp;เปลี่ยนยาง</MenuItem>
                                {/* <MenuItem eventKey="2"><FontAwesome name='bullseye' className='text-black' />&nbsp;หล่อดอก</MenuItem> */}
                                <MenuItem eventKey="4"><FontAwesome name='bullseye' className='text-black' />&nbsp;ซ่อมยาง</MenuItem>
                                <MenuItem eventKey="3"><FontAwesome name='bullseye' className='text-black' />&nbsp;วัดดอกยาง</MenuItem>
                            </DropdownButton>
                        </Box.Tools>)}                        
                    </Box.Header>
                    <Box.Body>
                        <Row>
                            <div className="float-left text-center " style={{padding:'10px',width:'300px'}}>
                                {this.renderVehicleTypeSelection()}
                                {activeMenu==='3'?this.renderTreadDepthCarModel():activeMenu==='1'?this.tyreChangeCarModel():activeMenu==='4'?this.tyreRepairCarModel():this.renderCarModel()}
                            </div>   
                            <div className="float-left" style={{width:'calc(100% - 320px)'}}>
                                {this.renderTab()}
                                {this.renderOperation()}
                            </div>    
                        </Row>
                        {mode!=='tyre-work-doc-entry-view'
                        ?
                        <Row style={{display:'none'}}>
                            <Col md={6}>
                                {this.renderGenForm()}
                            </Col>
                        </Row> 
                        :''}                        
                        {this.renderTable()}                        
                    </Box.Body>   
                    <Box.Footer>
                        <ButtonToolbar className='pull-right'>    
                            <Button onClick={this.props.onClose}><FontAwesome name='close' />&nbsp;ปิด</Button>
                        </ButtonToolbar>
                    </Box.Footer> 
                </Box>
            </div>	
            <NotificationSystem ref="notificationSystem" /> 	
            <ConfirmPopup 
                show={this.state.showConfirmDel}
                message='ยืนยันลบรถคันนี้ทิ้งถาวร ?'
                onConfirm={this.onCarConfirmDel.bind(this)}
                onHide={()=>{this.setState({showConfirmDel:false})}}
            />	 
            <ConfirmPopup 
                show={this.state.showModeChange}
                message={'มีการเปิดรายการ'+(activeMenu==='0'?'สลับยาง':activeMenu==='1'?'เปลี่ยนยาง':activeMenu==='2'?'หล่อดอก':activeMenu==='3'?'วัดดอกยาง':activeMenu==='4'?'ซ่อมยาง':'---')+'อยู่ ท่านต้องการเปลี่ยนไปโหมด'+(_activeMenu==='0'?'สลับยาง':_activeMenu==='1'?'เปลี่ยนยาง':_activeMenu==='2'?'หล่อดอก':_activeMenu==='3'?'วัดดอกยาง':_activeMenu==='4'?'ซ่อมยาง':'---')+'หรือไม่ ?'}
                onConfirm={this.onModeChangeConfirmClick.bind(this)}
                onHide={()=>{this.setState({showModeChange:false,_activeMenu:undefined})}}
            />	      
	    </div>  
    )
  }
}

AssetVehicleServiceDoc.defaultProps = {
    mode: '',
    showNewItem:false,
    items: {}
}

export default AssetVehicleServiceDoc = connect(
    (state) => ({messages: state.message.view.tyre.AssetVehicleServiceDoc}),null,null,{withRef:true}
)(AssetVehicleServiceDoc);


// WEBPACK FOOTER //
// ./src/view/tyre/AssetVehicleServiceDoc.js